import React from 'react';

const BodyText = ({ description, children }) => {
    return <p className="mb-8 leading-relaxed">
        {description || children}
    </p>
};

export default BodyText;